import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

// CONFIGS
import { PaginationConfig } from '../../../shared';

// INTERFACES
import { SupplierApiService } from '../../../shared/services/api/supplier/supplier-api.service';
import { SupplierSkuApiService } from '../../../shared/services/api/supplier/supplier-sku-api.service';
import { trackById } from '../../../shared/util/track-by.util';
import { ISupplierSku } from '../../../supplier/interfaces/supplier-sku.interface';

// SERVICES

// UTILS

@Component({
  selector: 'lum-rfq-supplier-skus',
  templateUrl: './rfq-supplier-skus.component.html',
  styleUrls: ['./rfq-supplier-skus.component.scss'],
})
export class RfqSupplierSkusComponent implements OnInit {
  form :UntypedFormGroup;
  loading :boolean = false;
  paginationConfig = PaginationConfig;
  pagination :any = {};
  supplierSkus :ISupplierSku[] = [];
  params :{ [param :string] :string | string[] } = {
    relations: 'supplier,product',
  };
  loadingSupplier :boolean = false;
  suppliers :ISupplierSku[] = [];
  defaultSupplierFilter :null | string = null;

  trackById = trackById;

  private onDestroy$ = new Subject<void>();

  constructor(
    private fb :UntypedFormBuilder,
    private cd :ChangeDetectorRef,
    private supplierApiService :SupplierApiService,
    private supplierSkuApiService :SupplierSkuApiService,
  ) {}

  ngOnInit() :void {
    this.initForm();
    this.getSupplierSkus();

    this.getSuppliers();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onPaginationEvent(pagination :PageEvent) :void {
    this.params = {
      ...this.params,
      limit: pagination.pageSize.toString(),
      page: (pagination.pageIndex + 1).toString(),
    };
    this.getSupplierSkus();
  }

  onSelectSupplierFilter(supplierId :number) :void {
    if (supplierId) {
      this.params = {
        ...this.params,
        supplierIds: supplierId.toString(),
      };
    } else {
      delete this.params.supplierIds;
    }

    this.getSupplierSkus();
  }

  private initForm() :void {
    this.form = this.fb.group({
      supplierSkus: this.fb.array([]),
    });
  }

  private getSuppliers() :void {
    this.loadingSupplier = true;
    this.supplierApiService
      .get({})
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loadingSupplier = false)),
      )
      .subscribe({
        next: (response) => {
          const { records } = response;
          const formattedSuppliers = records.map((supplier) => ({
            ...supplier,
            factoryName: supplier.factory_name,
          }));
          this.suppliers = formattedSuppliers;
        },
      });
  }

  private getSupplierSkus() :void {
    this.loading = true;
    this.supplierSkuApiService
      .get({ ...this.params })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => this.cd.detectChanges()),
      )
      .subscribe({
        next: (response) => {
          const { data, meta } = response;
          this.supplierSkusControl.clear();
          data.forEach((supplierSku) => {
            this.supplierSkusControl.push(this.fb.group(supplierSku));
          });
          this.pagination = meta;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  get supplierSkusControl() :UntypedFormArray {
    return this.form.get('supplierSkus') as UntypedFormArray;
  }
}
